import { useAuthStore } from '@/stores/auth'
import api, { API_URLS } from './api'
import type { LoginResponse, AccountResponse } from '@/types/auth'
// import type { ApiResponse } from '@/types/api'
// import type { User } from '@/types/user'

interface SendVerificationCodeResponse {
  code: number
  message: string
  data?: any
}

interface RegisterResponse {
  code: number
  message: string
  data?: any
}

interface RefreshTokenResponse {
  code: number
  message: string
  data: {
    token: string
    expires_at: number
  }
}

export const authApi = {
  login: async (data: {
    loginType: string
    account: string
    password: string
    verifyCode: string | undefined
  }): Promise<LoginResponse> => {
    const response = await api.post(API_URLS.AUTH.LOGIN, data)
    return response.data
  },

  getAccount: async () => {
    const response = await api.get(API_URLS.AUTH.GET_USER)
    return response.data
  },

  sendVerificationCode: async (data: {
    email: string
  }): Promise<SendVerificationCodeResponse> => {
    const response = await api.get(API_URLS.AUTH.SEND_VERIFICATION_CODE, {
      params: data,
    })
    return response.data
  },

  register: async (data: {
    userName: string
    userPassword: string
    inviteCode: string
    userEmail: string
    userPhone: string
    verifyCode: string
  }): Promise<RegisterResponse> => {
    const response = await api.post(API_URLS.AUTH.REGISTER, data)
    return response.data
  },

  refreshToken: async (): Promise<RefreshTokenResponse> => {
    const response = await api.post(API_URLS.AUTH.REFRESH_TOKEN)
    return response.data
  },

  logout: async () => {
    const response = await api.post(API_URLS.AUTH.LOGOUT)
    return response.data
  },
}

// export default api
